import { ValidationModel, ValidationType } from "@/services/validation/types";

export const authorizationValidators = {
    credentialsName: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 1 }
        ]
    } as ValidationModel,
    clientId: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 1 }
        ]
    } as ValidationModel,
    clientSecret: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 1 }
        ]
    } as ValidationModel,
    scopes: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 1 }
        ]
    } as ValidationModel,
    tenantId: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 1 }
        ]
    } as ValidationModel,
    username: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 1 }
        ]
    } as ValidationModel,
    password: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 1 }
        ]
    } as ValidationModel
};
